import { useEffect, useState } from 'react';
import {
    FormControl,
    FormLabel,
    Text,
    Stack,
    Box,
    FormErrorMessage,
} from '@chakra-ui/react';
import { Field } from 'formik';
import DropDown from '@/components/forms/new/formikFormFields/DropDown';
import TriggerFieldToolTip from './TriggerFieldToolTip';
import { useTriggerForm } from '../useTriggerForm.js';
import { FORM_FIELD_PATHS } from '../triggerFormConstants.js';
import config from '../../../../../config.json';
import walkthroughIds from '../../walkthroughIds';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';

const WebhookMethodInput = ({ darkMode, errors, touched }) => {
    const { editMode } = walkthroughIds;
    const [isHovered, setIsHovered] = useState(false);
    const { formData, updateFormData } = useTriggerForm();

    const handleSelectChange = (item) => {
        const httpMethod = item?.name || item;
        updateFormData(FORM_FIELD_PATHS.HTTP_METHOD, httpMethod);
    };

    const httpMethodData = config.triggers.httpMethod.map((method) => ({
        id: method,
        name: method,
    }));

    useEffect(() => {
        updateFormData(
            FORM_FIELD_PATHS.HTTP_METHOD,
            formData?.action?.httpMethod,
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <FormControl
            sx={{ margin: '0 !important', position: 'relative' }}
            isInvalid={!!errors?.httpMethod && touched?.httpMethod}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={stackStyling(true)}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Method <span style={{ color: '#e53e3e' }}>*</span>
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Select the HTTP method for the webhook request.
                    </Text>
                </Box>
                <Box flex={1} paddingTop="15px" maxWidth="400px">
                    <Field
                        component={DropDown}
                        id={FORM_FIELD_PATHS.HTTP_METHOD}
                        name={FORM_FIELD_PATHS.HTTP_METHOD}
                        data={httpMethodData}
                        shownValue="name"
                        currentId={formData?.action?.httpMethod}
                        selectedId="id"
                        placeholder="Select Method"
                        width="100%"
                        handleSelectChange={handleSelectChange}
                        isLoading={false}
                        darkMode={darkMode}
                        walkthroughId={editMode.ufWebHookMethod}
                        validate={(value) => {
                            if (!value) {
                                return 'Please select an HTTP method';
                            }
                        }}
                    />
                    {errors?.httpMethod && touched?.httpMethod && (
                        <FormErrorMessage>{errors.httpMethod}</FormErrorMessage>
                    )}
                    <TriggerFieldToolTip
                        isVisible={isHovered}
                        label="Choose the appropriate HTTP method: GET for retrieving data, POST for creating resources, PUT for updating, DELETE for removing."
                        ariaLabel="webhook-method-tip"
                    />
                </Box>
            </Stack>
        </FormControl>
    );
};

export default WebhookMethodInput;
